import './App.css';
import TodoList from './components/TodoList';

function App() {
  return (
    <div className='todo-container'>
      <TodoList />
    </div>
  );
}

export default App;
